<template>
    <div id="app">
        <popin v-if="popin"></popin>
        <div class="wrapper">
            <main-navigation></main-navigation>
            <component ref="etreAgir" :is="etreAgir" v-if="visible()"></component>
            <transition mode="out-in" name="fade">
                <router-view :key="$route.fullPath"/>
            </transition>
        </div>
        <groupama-footer></groupama-footer>
    </div>
</template>

<script>
    let tag = new ATInternet.Tracker.Tag();

    export default {
        name: 'App',
        data() {
            return {
                tag: tag,
                base_url: process.env.VUE_APP_PATH,
                popin: true,
                menuMobile: false,
            }
        },
        watch: {
            '$route.name': {
                handler: function (name) {
                    this.tag.page.send({name: 'UK_' + name});
                },
                deep: true,
                immediate: true
            }
        },
        computed: {
            maxHeight() {
                if (window.innerWidth < 500)
                    return window.innerHeight - window.innerHeight / 3 + 'px'
                if (window.innerWidth < 800)
                    return window.innerHeight - window.innerHeight / 5 + 'px'
                if (window.innerWidth < 1025)
                    return window.innerHeight - window.innerHeight / 2.8 + 'px'

                return window.innerHeight - 100 + 'px'
            },
            etreAgir: () => {
                return 'etre-agir';

                if (navigator.userAgent.match(/Android/i)
                    || navigator.userAgent.match(/webOS/i)
                    || navigator.userAgent.match(/iPhone/i)
                    || navigator.userAgent.match(/iPad/i)
                    || navigator.userAgent.match(/iPod/i)
                    || navigator.userAgent.match(/BlackBerry/i)
                    || navigator.userAgent.match(/Windows Phone/i)
                    || window.innerWidth < 500
                )
                    return 'etre-agir'
                else
                    return 'etre-agir'
            },
        },
        mounted() {
            if (this.isMacintosh())
                document.querySelector('body').classList.add('macos');
            if (this.isWindows())
                document.querySelector('body').classList.add('windows');
        },
        methods: {
            isMacintosh() {
                return navigator.platform.indexOf('Mac') > -1
            },
            isWindows() {
                return navigator.platform.indexOf('Win') > -1
            },
            visible() {
                let currentRoute = this.$route.name;
                return currentRoute === 'Home' || currentRoute === 'Etre' || currentRoute === 'Agir' || currentRoute === 'Transition';
            },
        }
    }
</script>

<style lang="scss">
    .windows {
        .agir span span:first-child {
            line-height: 1 !important;
            transform: translate(-105%, 130%);
        }
        .agir span, .etre span {
            line-height: 2.5 !important;
        }

    }
    .macos {
        .agir-menu {
            span.rotate {
                span {
                    &:last-child {
                        color: #a1bf38;
                        font-size: 170px;
                        line-height: 1.3 !important;
                    }
                }

            }
        }
    }

    .wrapper {
        min-height: 100%;
    }

    .groupama-footer {
        height: 260px;
    }

    @font-face {
        font-family: 'Canaro';
        src: url('./assets/fonts/Canaro-Light.woff2') format('woff2'),
        url('./assets/fonts/Canaro-Light.woff') format('woff');
        font-weight: 300;
        font-style: normal;
    }

    @font-face {
        font-family: 'Canaro';
        src: url('./assets/fonts/Canaro-Medium.woff2') format('woff2'),
        url('./assets/fonts/Canaro-Medium.woff') format('woff');
        font-weight: 500;
        font-style: normal;
    }

    @font-face {
        font-family: 'Canaro Book';
        src: url('./assets/fonts/Canaro-BookItalic.woff2') format('woff2'),
        url('./assets/fonts/Canaro-BookItalic.woff') format('woff');
        font-weight: normal;
        font-style: italic;
    }

    @font-face {
        font-family: 'Canaro';
        src: url('./assets/fonts/Canaro-Bold.woff2') format('woff2'),
        url('./assets/fonts/Canaro-Bold.woff') format('woff');
        font-weight: bold;
        font-style: normal;
    }

    @font-face {
        font-family: 'Minion Pro';
        src: url('./assets/fonts/MinionPro-Regular.woff2') format('woff2'),
        url('./assets/fonts/MinionPro-Regular.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'Canaro';
        src: url('./assets/fonts/Canaro-Black.woff2') format('woff2'),
        url('./assets/fonts/Canaro-Black.woff') format('woff');
        font-weight: 900;
        font-style: normal;
    }

    @font-face {
        font-family: 'Canaro';
        src: url('./assets/fonts/Canaro-ExtraBold.woff2') format('woff2'),
        url('./assets/fonts/Canaro-ExtraBold.woff') format('woff');
        font-weight: 800;
        font-style: normal;
    }

    @font-face {
        font-family: 'Canaro Book';
        src: url('./assets/fonts/Canaro-Book.woff2') format('woff2'),
        url('./assets/fonts/Canaro-Book.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }

    @font-face {
        font-family: 'Canaro';
        src: url('./assets/fonts/Canaro-SemiBold.woff2') format('woff2'),
        url('./assets/fonts/Canaro-SemiBold.woff') format('woff');
        font-weight: 600;
        font-style: normal;
    }

    @font-face {
        font-family: 'ChaletComprime-HongKongEighty';
        src: url('./assets/fonts/ChaletComprime-HongKongEighty.woff2') format('woff2'),
        url('./assets/fonts/ChaletComprime-HongKongEighty.woff') format('woff');
        font-weight: normal;
        font-style: normal;
    }


    .fade-enter-active, .fade-leave-active {
        transition: opacity .25s ease;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    html, body {
        margin: 0;
        height: 100%;
        font-family: Canaro, sans-serif;
        background: #006b58;
        color: #0b0b0b;
        max-width: 100%;
    }

    *, *::before, *::after {
        box-sizing: border-box;
    }

    #app {
        background: #006b58;
        height: 100%;
        font-family: Canaro, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>
